import React from 'react';
import { TCN, TCN_COLOR_MAP } from './tokens';

/**
 * TCN Card — surface1 background, 1px border, 16px radius, 16px padding.
 * Optional `accent` prop draws a 2px stripe on top in the chosen accent color.
 *
 * Props:
 *  - accent: 'cyan' | 'magenta' | 'green' | 'amber' | 'red' | 'diamond' | css color
 *  - padded: boolean (default true) — set false for full-bleed content (e.g. tables)
 *  - className, style, onClick, children
 */
const Card = ({
  accent,
  padded = true,
  className = '',
  style,
  children,
  onClick,
  ...rest
}) => {
  const accentColor = accent ? (TCN_COLOR_MAP[accent] ?? accent) : null;

  return (
    <div
      onClick={onClick}
      className={`relative bg-tcn-surface1 border border-tcn-border rounded-2xl ${padded ? 'p-4' : ''} ${onClick ? 'cursor-pointer' : ''} ${className}`}
      style={{ overflow: 'hidden', ...style }}
      {...rest}
    >
      {accentColor && (
        <div
          aria-hidden="true"
          style={{
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            height: 2,
            background: accentColor,
            // No box-shadow per mockup ui-kit.jsx:131 — stripe is flat.
          }}
        />
      )}
      {children}
    </div>
  );
};

export default Card;
